const it_extra = {
  clients: {
    title: "Pipeline Clienti",
    subtitle: "Gestisci richieste, trattative e conferme.",
    new_client: "Nuovo Cliente",
    new_client_title: "Nuovo cliente",
    partner1: "Partner 1",
    partner2: "Partner 2",
    email: "Email",
    phone: "Telefono",
    wedding_date: "Data matrimonio",
    acquisition: "Canale acquisizione",
    create: "Crea cliente",
    counts: {
      total: "Totale",
      negotiating: "In trattativa",
      confirmed: "Confermati",
      done: "Conclusi",
      lost: "Persi",
    },
    search_placeholder: "Cerca per nome o email",
    all_stages: "Tutti gli stage",
    linked_event_pill: "Evento collegato",
    no_clients: "Nessun cliente",
    no_clients_subtitle: "Aggiungi il tuo primo cliente per partire.",
    no_clients_search: "Nessun risultato",
    no_clients_search_subtitle: "Nessun cliente corrisponde alla ricerca o al filtro attivo.",
    wedding: "Matrimonio",
    tab: {
      panoramica: "Panoramica",
      evento: "Evento",
      comunicazioni: "Comunicazioni",
      questionario: "Questionario",
      documenti: "Documenti",
      note: "Note",
    },
    detail: {
      data_title: "Dati cliente",
      crm_title: "CRM",
      type: "Tipo",
      stage: "Stage",
      updated: "Aggiornato",
      linked_event: "Evento collegato",
      open_event: "Apri evento",
      go_event: "Vai all'evento →",
      no_event: "Nessun evento collegato.",
      no_event_title: "Nessun matrimonio ancora collegato",
      no_event_hint: "Promuovi il cliente per creare un evento pre-compilato con nome (partner) e data del matrimonio. I dati di contatto restano nella CRM.",
      promote_to_event: "Promuovi a evento",
      promoted_ok: "Evento creato e collegato al cliente",
      no_comms: "Nessuna comunicazione.",
      channel: "Canale",
      all_channels: "Tutti i canali",
      new_comm: "Nuova interazione",
      synthesis: "Sintesi",
      outcome: "Esito",
      save: "Salva",
      saved: "Note salvate",
      notes_label: "Note interne",
      send_questionnaire: "Invia link questionario",
      questionnaire_title: "Questionario",
      questionnaire_desc: "Invio automatico di un link personalizzato al cliente.",
      documents_placeholder: "Upload documenti dedicato al cliente.",
      coming_soon: "Prossimamente",
      stage_updated: "Stage aggiornato a \"{{stage}}\"",
    },
  },
  calendar: {
    title: "Agenda centralizzata",
    new_alert: "Nuovo Avviso",
    new_alert_title: "Nuovo avviso",
    title_label: "Titolo",
    date: "Data",
    type: "Tipo",
    legend: {
      Pagamento: "Pagamento",
      Task: "Task",
      Promemoria: "Promemoria",
      Avviso: "Avviso",
      Google: "Google",
      Evento: "Evento",
    },
    days: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
    no_events: "Nessun evento in questa data.",
    saved: "Avviso aggiunto",
    today: "Oggi",
    add_here: "Aggiungi qui",
    quick_add_title: "Nuova nota o impegno",
    notes_label: "Note (facoltative)",
    cancel: "Annulla",
  },
  suppliers: {
    title: "Rubrica Fornitori",
    subtitle: "Il tuo network di fornitori, riutilizzabile su ogni evento.",
    new_supplier: "Nuovo Fornitore",
    new_supplier_title: "Nuovo fornitore",
    name: "Nome",
    category: "Categoria",
    price_range: "Fascia",
    email: "Email",
    phone: "Telefono",
    rating: "Valutazione",
    rating_label_full: "Valutazione (0–5 stelle)",
    rating_help: "Il tuo voto interno sul fornitore — 0 = non ancora valutato, 5 = eccellente.",
    notes: "Note",
    all_categories: "Tutte le categorie",
    search_placeholder: "Cerca per nome",
    empty_title: "Rubrica vuota",
    empty_subtitle: "Aggiungi il primo fornitore al tuo network.",
    rating_label: "Voto",
    band_label: "Fascia",
    added: "Fornitore aggiunto",
    updated: "Fornitore aggiornato",
    deleted: "Fornitore rimosso",
    delete_confirm: "Eliminare definitivamente questo fornitore dalla rubrica?",
    edit_title: "Modifica fornitore",
    modal_eyebrow: "Rubrica fornitori",
    save_supplier: "Salva fornitore",
    update_supplier: "Aggiorna fornitore",
    events_managed: "Eventi gestiti: {{n}}",
    tabs: {
      anagrafica: "Anagrafica",
      contatti: "Contatti",
      amministrazione: "Amministrazione",
    },
    fields: {
      name: "Nome fornitore",
      category: "Categoria",
      city: "Città",
      contact_person: "Referente",
      email: "Email",
      phone: "Telefono",
      website: "Sito web",
      instagram: "Instagram",
      notes: "Note interne",
      agency_discount: "Sconto agenzia",
      iban: "IBAN",
      account_holder: "Intestatario conto",
      account_holder_hint: "Se diverso dalla ragione sociale",
      deposit_required: "Acconto richiesto",
      payment_terms: "Termine saldo",
      rating: "Valutazione interna",
    },
    placeholders: {
      name: "Es. Villa Medici",
      city: "Es. Milano",
      contact_person: "Es. Marco Bianchi",
      email: "info@...",
      phone: "+39 ...",
      website: "https://...",
      instagram: "@nomeprofilo",
      notes: "Note rapide o promemoria...",
      agency_discount: "es. 10",
      deposit_required: "es. 30",
      iban: "IT60 X054 2811 1010 0000 0123 456",
      account_holder: "Nome e Cognome o Ragione Sociale",
      payment_terms: "Seleziona termine...",
      regime: "Seleziona regime...",
    },
    fiscal_section: "Dati fiscali",
    economic_section: "Condizioni economiche",
    evaluation_section: "Valutazione interna",
    fiscal: {
      legal_name: "Ragione sociale",
      legal_name_hint: "Es. Villa Medici S.r.l.",
      vat_number: "Partita IVA",
      tax_code: "Codice fiscale",
      sdi_code: "Codice SDI",
      regime_fiscale: "Regime fiscale",
      pec_email: "PEC",
      address: "Indirizzo sede legale",
    },
    stats_section: "Statistiche",
    stats_events_label: "Eventi gestiti con questo fornitore",
    stats_events_hint: "Conteggio totale dei collegamenti in eventi attivi e passati.",
    contracts: {
      section: "Contratti",
      moved_hint: "I contratti di questo fornitore si caricano e si gestiscono dentro l'evento, nel tab «Contratti». Così ogni matrimonio ha i suoi contratti.",
      format_hint: "Formati accettati: PDF · DOCX · CSV.",
      upload: "Carica contratto",
      uploading: "Caricamento…",
      uploaded: "Contratto caricato",
      empty: "Nessun contratto caricato. Aggiungi qui i contratti del fornitore.",
      download: "Scarica",
      remove: "Rimuovi",
      delete_confirm: "Eliminare questo contratto? Sarà rimosso anche dagli eventi collegati.",
    },
  },
  settings: {
    title: "Profilo & Studio",
    account_title: "Account",
    name: "Nome",
    agency: "Nome agenzia",
    email: "Email",
    greeting: "Saluto",
    greeting_neutro: "Neutro",
    greeting_signora: "Signora",
    greeting_signor: "Signor",
    saved: "Profilo aggiornato",
    theme_lang_title: "Tema & Lingua",
    theme: "Tema",
    language: "Lingua",
    italian: "Italiano",
    english: "English",
    logo_title: "Logo agenzia",
    logo_desc: "Carica un logo PNG, JPG o SVG (consigliato 200×200, max 2MB). Sarà visualizzato in sidebar.",
    google_title: "Google Calendar",
    google_desc: "Collega il tuo account Google: matrimoni, task, pagamenti e promemoria di Aurea appariranno in un calendario dedicato \"Aurea Pro\", aggiornato da solo entro pochi minuti.",
    google_connect: "Collega Google Calendar",
    google_disconnect: "Scollega",
    google_reconnect: "Ricollega",
    google_connected_as: "Collegato come",
    google_last_sync: "Ultima sincronizzazione",
    google_never: "mai",
    google_sync_now: "Sincronizza ora",
    google_sync_started: "Sincronizzazione avviata",
    google_sync_running: "Sincronizzazione già in corso…",
    google_expired: "Google Calendar disconnesso. Ricollega l'account.",
    google_not_configured: "Integrazione Google non configurata sul server.",
    google_prefs_title: "Cosa sincronizzare",
    google_pref_events: "Matrimoni",
    google_pref_tasks: "Task",
    google_pref_payments: "Pagamenti",
    google_pref_reminders: "Promemoria",
    google_connected_toast: "Google Calendar collegato",
    google_error_toast: "Collegamento Google non riuscito",
    google_disconnected_toast: "Google Calendar scollegato",
    upload_logo: "Carica logo",
    remove_logo: "Rimuovi logo",
    plan_title: "Piano abbonamento",
    plan_label: "Piano",
    plan_active: "Piano attivo",
    plan_activate: "Attiva con Stripe",
    plan_downgrade: "Passa a Base",
    plan_downgrade_done: "Piano impostato su Base",
    plan_purchased_at: "Acquistato il",
    plan_trial_ends_at: "La prova gratuita termina il",
    plan_expires_at: "Scade il",
    // Premium a vita concesso dall'admin: gratuito, non scade, non si rinnova.
    plan_status_lifetime: "A vita",
    plan_lifetime_label: "Accesso",
    plan_lifetime_never_expires: "Per sempre",
    plan_lifetime_note: "Premium a vita. Nessun rinnovo e nessun addebito.",
    plan_renews_at: "Prossimo rinnovo",
    plan_holder: "Intestatario",
    plan_interval: "Frequenza",
    plan_interval_month: "Mensile",
    plan_interval_year: "Annuale",
    plan_days_left: "{{n}} giorni residui",
    plan_premium_note: "Il rinnovo automatico non è ancora attivo in questa versione: riceverai un promemoria 7 giorni prima della scadenza con un link Stripe per rinnovare.",
    plan_autorenew_on: "Rinnovo automatico attivo. Ti avviseremo via email 7 giorni prima del prossimo addebito.",
    plan_autorenew_off: "Rinnovo automatico disattivato. Rinnova manualmente per restare attivo.",
    plan_status: "Stato",
    plan_status_active: "Attivo",
    plan_status_trial: "Sei nella versione di prova",
    plan_status_past_due: "Pagamento fallito",
    plan_status_canceled: "Annullato",
    plan_status_expiring: "In scadenza",
    plan_renew_now: "Rinnova ora",
    plan_admin_active: "Piano admin — gestito manualmente",
    plan_billing_not_linked: "Pagamenti Stripe non ancora collegati a questo account. Collegali per gestire rinnovi e fatture.",
    plan_link_stripe: "Collega pagamenti Stripe",
    plan_manage: "Gestisci abbonamento",
    plan_change_plan: "Cambia piano",
    billing_cycle: "Ciclo di fatturazione",
    billing_monthly: "Mensile",
    billing_yearly: "Annuale",
    billing_yearly_save: "12 mesi al prezzo di 12 — nessun sconto extra",
    billing_per_month: "/mese",
    billing_per_year: "/anno",
    billing_yearly_equiv: "{{price}} all'anno",
    stripe_test_notice: "Stripe in modalità test: usa la carta 4242 4242 4242 4242 con qualsiasi CVC e scadenza futura.",
    stripe_redirect: "Reindirizzamento a Stripe…",
    portal_redirect: "Apertura portale Stripe…",
    base_caps: ["Max 3 eventi attivi", "Tutte le funzioni core", "Supporto via email"],
    premium_caps: [
      "Eventi illimitati",
      "Multi-utente / team",
      "Piano tavoli drag&drop",
      "Import CSV invitati + RSVP pubblica",
      "Priorità supporto",
    ],
    team_title: "Membri team",
    team_owner: "Proprietario",
    team_collaborator: "Collaboratore",
    team_empty: "Nessun collaboratore invitato.",
    team_invite: "Invita Membro",
    team_invite_title: "Invita collaboratore",
    team_invited: "Invito inviato",
    team_removed: "Membro rimosso",
    // Motivi dell'eliminazione account. I codici dopo delete_reason_ devono
    // combaciare con DELETION_REASONS in backend/services/account_deletion.py:
    // il codice va a database, questo testo no.
    delete_reason_costo: "Costa troppo",
    delete_reason_poco_utilizzo: "Non lo uso abbastanza",
    delete_reason_attivita_chiusa: "Ho chiuso o sospeso l'attività",
    delete_reason_altro_gestionale: "Sono passata a un altro gestionale",
    delete_reason_funzioni_mancanti: "Mancano funzioni che mi servono",
    delete_reason_troppo_complicato: "Troppo complicato da usare",
    delete_reason_problemi_tecnici: "Problemi tecnici o errori",
    delete_reason_account_di_prova: "Era solo un account di prova",
    delete_reason_privacy: "Preoccupazioni sulla privacy dei dati",
    delete_reason_non_dico: "Preferisco non dirlo",
    // Unità del riepilogo "stai per eliminare 5 eventi, 23 clienti…".
    // Servono entrambe le forme: senza il singolare si legge "1 eventi".
    delete_unit_events_one: "evento",
    delete_unit_clients_one: "cliente",
    delete_unit_suppliers_one: "fornitore",
    delete_unit_guests_one: "ospite",
    delete_unit_payments_one: "pagamento",
    delete_unit_files_one: "file",
    delete_unit_events: "eventi",
    delete_unit_clients: "clienti",
    delete_unit_suppliers: "fornitori",
    delete_unit_guests: "ospiti",
    delete_unit_payments: "pagamenti",
    delete_unit_files: "file",
  },
  billing: {
    success_title: "Pagamento confermato",
    success_msg: "Il tuo piano Premium è attivo. Scopri tutte le nuove funzioni.",
    success_msg_base: "Il tuo piano Base è attivo. Grazie per averci scelto.",
    polling: "Verifica del pagamento in corso…",
    failed: "Pagamento non confermato. Riprova dalle impostazioni.",
    back_to_settings: "Torna alle impostazioni",
    go_dashboard: "Vai alla dashboard",
    cancelled: "Pagamento annullato. Puoi riprovare quando vuoi.",
  },
  rsvp: {
    page_title: "Conferma la tua presenza",
    your_name: "Il tuo nome",
    your_email: "La tua email",
    pax_label: "Numero ospiti (incluso te)",
    diet_label: "Allergie / intolleranze",
    diet_placeholder: "es. Vegetariano, Senza glutine…",
    allergies_label: "Allergie alimentari",
    allergies_placeholder: "es. Arachidi, Frutta a guscio, Glutine (celiachia)",
    intolerances_label: "Intolleranze / preferenze",
    intolerances_placeholder: "es. Lattosio, Vegetariano, Vegano",
    notes_label: "Note per gli sposi",
    rsvp_yes: "Confermo presenza",
    rsvp_no: "Non potrò esserci",
    submit: "Invia",
    submitted: "Grazie! La tua risposta è stata registrata.",
    not_found: "Evento non trovato.",
    invalid_link: "Link RSVP non valido o disattivato.",
  },
  diet: {
    diet: "Dieta",
    allergies: "Allergie",
    allergies_short: "Allergia",
    intolerances: "Intolleranze",
    intolerances_short: "Intolleranza",
    has_restrictions: "{{n}} con restrizioni",
    no_restrictions: "Nessuna restrizione segnalata",
    add_chip: "Aggiungi e premi Invio",
    placeholder_allergies: "es. Arachidi, Glutine, Frutta a guscio",
    placeholder_intolerances: "es. Lattosio, Vegetariano, Vegano",
  },
  email_tpl: {
    section_title: "Email transazionali",
    section_desc: "Personalizza il contenuto delle email che invii agli sposi e ai clienti.",
    config_missing: "Configurazione mancante: imposta RESEND_API_KEY nelle variabili d'ambiente del backend per inviare email reali. I template restano salvati comunque.",
    config_ok: "Servizio email attivo. Mittente: {{sender}}",
    types: {
      payment_reminder: "Promemoria pagamento sposi",
      questionnaire: "Invio questionario cliente",
      welcome: "Welcome cliente confermato",
    },
    subject: "Oggetto",
    body: "Contenuto HTML",
    body_hint: "Puoi usare HTML basico (<strong>, <em>, <a>, <p>) per la formattazione.",
    save: "Salva template",
    saved: "Template aggiornato",
    reset: "Ripristina default",
    reset_done: "Template ripristinato",
    test_send: "Invio di prova",
    test_send_title: "Invia email di test",
    recipient: "Destinatario",
    pick_client: "Scegli sposi (cliente)",
    pick_client_placeholder: "Seleziona dalla rubrica clienti…",
    pick_client_hint: "Selezionando una coppia, email e variabili vengono compilate automaticamente.",
    send: "Invia",
    sent: "Email inviata",
    variables: "Variabili disponibili",
    is_custom: "Personalizzato",
    is_default: "Default",
    logs_title: "Ultime email inviate",
    no_logs: "Nessuna email inviata.",
  },
  wp: {
    section_title: "Integrazione WordPress",
    section_desc: "Collega il plugin RSVP del tuo sito WordPress per ricevere automaticamente gli RSVP nel gestionale.",
    not_connected: "Non connesso. Genera la tua API key per collegare il plugin.",
    connected: "Connesso",
    synced_count: "RSVP sincronizzati",
    last_sync: "Ultimo sync",
    api_key: "Chiave API",
    key_once: "Copiala adesso: non verra' mostrata di nuovo",
    key_hidden: "Nascosta. Rigenera la chiave per averne una nuova.",
    ingest_url: "Endpoint RSVP (POST)",
    events_url: "Endpoint Eventi (GET)",
    header_label: "Header autorizzazione",
    copy: "Copia",
    copied: "Copiato",
    generate: "Genera chiave API",
    regenerate: "Rigenera chiave",
    regenerated: "Chiave rigenerata",
    disconnect: "Disconnetti",
    disconnected: "Integrazione disconnessa",
    docs_title: "Come usare",
    docs_lines: [
      "1. Installa il plugin Aurea Pro RSVP nel tuo sito WordPress.",
      "2. Inserisci la chiave API qui sotto nelle impostazioni del plugin.",
      "3. Il plugin chiamerà automaticamente l'endpoint per recuperare la lista degli eventi.",
      "4. Quando un ospite invia un RSVP dal sito, il plugin invierà un POST all'endpoint RSVP.",
    ],
    payload_title: "Esempio payload",
  },
  guests: {
    add_title: "Aggiungi invitato",
    edit_title: "Modifica invitato",
    name: "Nome",
    email: "Email",
    phone: "Telefono",
    rsvp_status: "Stato RSVP",
    group_family: "Gruppo / Famiglia",
    group_family_hint: "es. Famiglia Rossi",
    dietary_section: "Preferenze alimentari",
    menu_choice: "Menù",
    menu_placeholder: "— Menù —",
    menu_inherits: "Eredita dal principale",
    allergies: "Allergie",
    intolerances: "Intolleranze",
    allergies_hint: "es. Glutine, Arachidi, Frutta a guscio",
    intolerances_hint: "es. Lattosio, Sorbitolo, Solfiti",
    yes: "Sì",
    no: "No",
    companions: "Accompagnatori",
    companion_add: "Aggiungi",
    companion_name: "Accompagnatore {{n}}",
    companions_empty: "Nessun accompagnatore — clicca \"Aggiungi\" per inserirne uno.",
    total: "Totale",
    person_one: "{{n}} persona",
    person_many: "{{n}} persone",
    table: "Tavolo",
    no_table: "— Nessun tavolo —",
    export_catering_csv: "Catering CSV",
    export_catering_pdf: "Catering PDF",
    delete_confirm: "Sei sicuro di voler eliminare questo invitato e i suoi accompagnatori?",
  },
};

export default it_extra;
